export default {
  'menu.welcome': '환영합니다',
  'menu.more-blocks': '더 많은 블록',
  'menu.home': '홈',
  'menu.console': '관리자',
  'menu.console.sub-page': '서브 페이지',
  'menu.login': '로그인',
  'menu.register': '회원가입',
  'menu.register-result': '회원가입 결과',
  'menu.dashboard': '대시보드',
  'menu.dashboard.analysis': '분석',
  'menu.dashboard.monitor': '모니터',
  'menu.dashboard.workplace': '워크플레이스',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': '폼',
  'menu.form.basic-form': '기본 폼',
  'menu.form.step-form': '단계 폼',
  'menu.form.step-form.info': '단계 폼(이체 정보 작성)',
  'menu.form.step-form.confirm': '단계 폼(이체 정보 확인)',
  'menu.form.step-form.result': '단계 폼(완료)',
  'menu.form.advanced-form': '고급 폼',
  'menu.list': '목록',
  'menu.list.table-list': '검색 테이블',
  'menu.list.basic-list': '기본 목록',
  'menu.list.card-list': '카드 목록',
  'menu.list.search-list': '검색 목록',
  'menu.list.search-list.articles': '검색 목록(기사)',
  'menu.list.search-list.projects': '검색 목록(프로젝트)',
  'menu.list.search-list.applications': '검색 목록(애플리케이션)',
  'menu.profile': '프로필',
  'menu.profile.basic': '기본 프로필',
  'menu.profile.advanced': '고급 프로필',
  'menu.result': '결과',
  'menu.result.success': '성공',
  'menu.result.fail': '실패',
  'menu.exception': '예외',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': '트리거',
  'menu.account': '계정',
  'menu.account.center': '계정 센터',
  'menu.account.settings': '계정 설정',
  'menu.account.trigger': '트리거 오류',
  'menu.account.logout': '로그아웃',
  'menu.account.profile': '프로필',
  'menu.console.agents': '에이전트',
  'menu.console.agentDevice': '에이전트 디바이스',
  'menu.console.devices': '디바이스',
  'menu.console.speakers': '화자 인식',
  'menu.console.voiceClone': '음성 복제',
  'menu.console.settings': '개인 설정',
  'menu.admin': '관리자',
  'menu.admin.dashboard': '대시보드',
  'menu.admin.settings': '설정',
  'menu.admin.providers': '모델 제공자',
  'menu.admin.unbindDevice': '디바이스 해제',
  'menu.admin.userManage': '사용자 관리',
  'menu.admin.systemConfig': '시스템 설정',
  'menu.admin.whiteList': '화이트리스트',
  'menu.admin.opsManage': '운영',
  'menu.admin.recorderManage': '레코더 관리',
  'menu.admin.deviceManage': '디바이스 관리',

  'menu.console.agentSetting': '에이전트 설정',

  };
